// extracted by mini-css-extract-plugin
export default {"answers":"answers_answers__4eZaf","answer":"answers_answer__9Gj8L","correct":"answers_correct__pW2uo","wrong":"answers_wrong__UN-sx"};